import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";

export interface IPositionCorrectionObject extends IRectangleCoordinatableObject {}

export function instanceOfIPositionCorrectionObject(instance: any): instance is IPositionCorrectionObject {
  return instanceOfIRectangleCoordinatableObject<IPositionCorrectionObject>(instance, "poscorrect");
}
